<template>
  <b-form @submit.prevent="guardar">
    <b-form-row>
      <b-col md="6">
        <b-badge v-text="'Peligros Físicos'"
                 class="w-100 badge-sga badge-fisicos"
        />
        <el-select v-model="selectedSeccion2.categoriasfisicas"
                   id="categoriasfisicas"
                   name="categoriasfisicas"
                   class="my-1"
                   multiple
                   clearable
                   filterable
                   v-validate="'required'"
                   data-vv-as=" "
                   @change="valores(selectedSeccion2.categoriasfisicas, 'fisicas')"
        >
          <el-option v-for="(fisico, index) in fisicos"
                     :key="index"
                     :value="fisico.id"
                     :label="fisico.categoria"
          />
        </el-select>

        <span class="text-danger span-error small"
              v-text="errors.first('formulario.categoriasfisicas')"
        />
      </b-col>

      <b-col md="6">
        <b-badge v-text="'Peligros de Salud'"
                 class="w-100 badge-sga badge-salud"
        />
        <el-select v-model="selectedSeccion2.categoriassalud"
                   id="categoriassalud"
                   name="categoriassalud"
                   class="my-1"
                   multiple
                   clearable
                   filterable
                   v-validate="'required'"
                   data-vv-as=" "
                   @change="valores(selectedSeccion2.categoriassalud, 'salud')"
        >
          <el-option v-for="(saludcat, index) in salud"
                     :key="index"
                     :value="saludcat.id"
                     :label="saludcat.categoria"
          />
        </el-select>

        <span class="text-danger span-error small"
              v-text="errors.first('formulario.categoriassalud')"
        />
      </b-col>

      <b-col md="6">
        <b-badge v-text="'Peligros en el Ambiente'"
                 class="w-100 badge-sga badge-ambiente"
        />
        <el-select v-model="selectedSeccion2.categoriasambiental"
                   id="categoriasambiental"
                   name="categoriasambiental"
                   class="my-1"
                   multiple
                   clearable
                   filterable
                   v-validate="'required'"
                   data-vv-as=" "
                   @change="valores(selectedSeccion2.categoriasambiental, 'ambiental')"
        >
          <el-option v-for="(ambiente, index) in ambiental"
                     :key="index"
                     :value="ambiente.id"
                     :label="ambiente.categoria"
          />
        </el-select>

        <span class="text-danger span-error small"
              v-text="errors.first('formulario.categoriasambiental')"
        />
      </b-col>

      <b-col md="6">
        <b-badge v-text="'Sustancias no peligrosas'"
                 class="w-100 badge-sga badge-no-peligrosas"
        />
        <el-select v-model="selectedSeccion2.categoriasNpeligrosas"
                   id="categoriasNpeligrosas"
                   name="categoriasNpeligrosas"
                   class="my-1"
                   multiple
                   clearable
                   filterable
                   v-validate="'required'"
                   data-vv-as=" "
                   @change="valores(selectedSeccion2.categoriasNpeligrosas, 'nopeligrosas')"
        >
          <el-option v-for="(peligrosa, index) in peligrosas"
                     :key="index"
                     :value="peligrosa.id"
                     :label="peligrosa.categoria"
          />

        </el-select>

        <span class="text-danger span-error small"
              v-text="errors.first('formulario.categoriasNpeligrosas')"
        />
      </b-col>
    </b-form-row>

    <hr>
    <FooterButtons back="/fds/listar" />
  </b-form>
</template>

<script>
import Swal from 'sweetalert2';
import {mapActions, mapMutations, mapState} from 'vuex';
import FooterButtons from '../../componentes/FooterButtons';
import {getJsonSga} from "../../../../servicios/productos/sistemasclasificacion/sga/actions";

export default {
  name: "FDS-Seccion2",
  components: {
    FooterButtons
  },
  data() {
    return {
    }
  },
  async created() {
    await this.setSeccionActual(2);
    let id_empresa = await this.obtenerIdEmpresaUsuario();
    await this.setIdEmpresaFdsProducto(id_empresa);
    await this.getJsonSga();
    if (this.$route.params.id_fds_producto !== undefined) {
      let id_fds_producto = this.$route.params.id_fds_producto;
      let data = {
        id_empresa: id_empresa,
        id_fds_producto: id_fds_producto,
      };
      await this.getSeccion(data);
      await this.setIdFdsProductoSeccion(id_fds_producto);
    } else {
      await this.resetSeccion();
    }
  },
  methods: {
    async guardar() {
      if (this.accion === 'crear') {
        await this.crearSeccion();
      } else if (this.accion === 'editar') {
        await this.actualizarSeccion();
      }
    },
    ...mapMutations('fds_productos', [
      'setSeccionActual',
      'setIdFdsProductoSeccion',
    ]),
    ...mapActions('dashboard', [
      'obtenerIdEmpresaUsuario',
    ]),
    ...mapActions('fds_productos', [
      'getSeccion',
      'crearSeccion',
      'actualizarSeccion'
    ]),
    ...mapMutations('fds_productos',[
      'setIdEmpresaFdsProducto',
      'setSeccionActual',
      'resetSeccion',
    ]),
    // Sga
    ...mapMutations('sga', [
      'restablecerSga',
      'restablecerPictogramas',
    ]),
    ...mapActions('sga', [
      'getJsonSga',
      'getSga',
      'getPictogramas',
      'getFrases',
      'guardarSga',
    ]),
    async valores(selectedSga, tipo) {
      if (tipo === 'fisicas') {
        for (let i = 0; i < selectedSga.length; i++) {
          // Si es 1 significa que no aplica
          if (selectedSga[i] === 1) {
            this.selectedSga.categoriasfisicas = [];
            this.selectedSga.categoriasfisicas.push(1);
          }
        }
      }
      if (tipo === 'salud') {
        for (let i = 0; i < selectedSga.length; i++) {
          if (selectedSga[i] === 51) {
            this.selectedSga.categoriassalud = [];
            this.selectedSga.categoriassalud.push(51);
          }
        }
      }
      if (tipo === 'ambiental') {
        for (let i = 0; i < selectedSga.length; i++) {
          if (selectedSga[i] === 92) {
            this.selectedSga.categoriasambiental = [];
            this.selectedSga.categoriasambiental.push(92);
          }
        }
      }
      if (tipo === 'nopeligrosas') {
        for (let i = 0; i < selectedSga.length; i++) {
          if (selectedSga[i] === 101) {
            this.selectedSga.categoriasNpeligrosas = [];
            this.selectedSga.categoriasNpeligrosas.push(101);
          }
        }
      }
    },
  },
  computed: {
    ...mapState('fds_productos',[
      'selectedSeccion2',
      'id_empresa',
      'accion',
    ]),
    ...mapState('sga', [
      'selectedSga',
      'fisicos',
      'salud',
      'ambiental',
      'peligrosas',
      'pictogramas'
    ]),
  }
}
</script>

<style>
.badge-sga {
  border-radius: 8px;
  height: 40px;
  color: white;
  padding: 14px;
  font-size: 14px;
  margin-top: 15px;
}

.badge-fisicos {
  background-color: #ff7d00;
}

.badge-salud {
  background-color: #1f487b;
}

.badge-ambiente {
  background-color: #36b564;
}

.badge-no-peligrosas {
  background-color: #55b543;
}
</style>
